import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-et004-card-II',
    templateUrl: './et004-card-II.component.html'
})

export class Et004CardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public isReadOnlyPoncho?: boolean;
    public isReadOnlyCruiser?: boolean;
    public isReadOnlyRedigo?: boolean;
    public isReadOnlyDermacor?: boolean;
    public isReadOnlyTSI?: boolean;
    public isReadOnlyCaldaConvencional?: boolean;

    public isReadOnlyAgua?: boolean;
    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcII = new EventEmitter();
    isReadOnlyLotePos: boolean = true;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Quantidade de Produto Consumido (g)', false);
        this.formulario = this.formBuilder.group({
            pump_station_calda_convencional: [null, []],
            pump_station_calda_tsi: [null, []],

            pump_station_poncho: [null, []],
            pump_station_cruiser: [null, []],
            pump_station_dermacor: [null, []],
            pump_station_redigo: [null, []],

            talkum_gloss: [null, []],
            correcao_limpeza_linha: [null, [Validators.min(0), Validators.max(5)]],

            ingrediente_ativo_laudo_produto_poncho: [null, []],
            correcao_ia_poncho: [null, []],
            correcao_perda_processo_poncho: [null, []],
            correcao_aplicacao_poncho: [null, []],


            correcao_aplicacao_prc: [null, []],
            // correcao_aplicacao_cruiser: [null, []],

            ingrediente_ativo_laudo_produto_dermacor: [null, []],
            correcao_ia_dermacor: [null, []],
            correcao_perda_processo_dermacor: [null, []],
            correcao_aplicacao_dermacor: [null, []],

            correcao_perda_processo_redigo: [null, []],
            correcao_aplicacao_redigo: [null, []],

            ingrediente_ativo_laudo_produto_cruiser: [null, []],
            ingrediente_ativo_laudo_produto_redigo: [null, []],

            correcao_total: [null, []],

        });

        this.formulario.get('correcao_aplicacao_poncho')['warning'] = false;
        this.formulario.get('correcao_aplicacao_dermacor')['warning'] = false;
        this.formulario.get('correcao_aplicacao_redigo')['warning'] = false;
    }

    async ngOnInit(): Promise<void> {
        // await Promise.all([this.checkBtnLeitorEnable(), this.getListSiteRecebimento()]);

    }
    verifyFormValuesMaxMin(event: KeyboardEvent) {
        const inputElement = event.target as HTMLInputElement;


        const min = 0;
        const max = 5;
        let changeValue = false;
        let value = this.formulario.get('correcao_limpeza_linha').value as number

        if (isNaN(value)) {
            value = min;
        }

        if (value > max) {
            value = value / 10;
            changeValue = true
        }
        if (changeValue) {

            this.formulario.get('correcao_limpeza_linha').setValue((Number(Math.floor(value * 100) / 100).toFixed(2)))
        }
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async makeCalculationsII(): Promise<void> {
        this.mkCalcII.emit();
    }
}


